<template>
	<div>
		<div>
			<breadcrumb :routerList="[{title:'采购项目'}]"/>
			<div class="h-content">
				<div class="h-row h-mrt0">
					<div class="h-rowIn">
						<div class="h-rowBox">
							<div class="h-rowCon">
								<div class="h-pieceIn2">
									<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
										<h1>基本信息</h1>
									</div>
									<div class="h-pieceCon2" style="padding:0">
										<div class="h-formLine initiate">
											<el-form :model="formLabelAlign" label-position="right" ref="cai"
													 :inline="true"
													 class="demo-ruleForm h-formbLine h-formbLine1">
												<el-form-item label="创建人" class="h-elformWrap-2"  >
													<el-input readonly v-model="formLabelAlign.cuname"></el-input>
												</el-form-item>
												<el-form-item label="创建时间" class="h-elformWrap-2"  >
													<el-input readonly v-model="formLabelAlign.cdate"></el-input>
												</el-form-item>
												<el-form-item label="项目编号" class="h-elformWrap-2" >
													<el-input readonly v-model="formLabelAlign.id"></el-input>
												</el-form-item>
												<el-form-item label="项目类别" class="h-elformWrap-2"  >
													<el-input readonly  :value="formLabelAlign.type|dictname('pro_type')"></el-input>
												</el-form-item>
												<el-form-item label="项目名称" class="h-elformWrap-2"  >
													<el-input readonly v-model="formLabelAlign.projectName"></el-input>
												</el-form-item>
												<el-form-item label="项目说明" class="h-elformWrap-2"
															  prop="projectDescription">
													<el-input readonly v-model="formLabelAlign.projectDescription"
															  maxlength="70" placeholder="请输入">
													</el-input>
												</el-form-item>
											</el-form>
										</div>
									</div>
								</div>
								<br/>
								<div class="N-chan ljjxjbjzdgys">
									<div class="h-pieceTitle2">
										<h1>询价信息</h1>
										<el-button size="small" type="primary" v-if="xunjiaflag"
												   icon="el-icon-circle-plus"
												   @click="showaddxunjzflagclick"
												   style="margin-left: 50px;" >添加询价
										</el-button>
									</div>

									<el-table
											ref="multipleTable"
											:data="grouplist"
											:border="true"
											style="width: 100%">
										<el-table-column
												type="index"
												width="40"
												label="#">
										</el-table-column>
										<el-table-column
												prop="prodid"
												label="产品编码"
												:show-overflow-tooltip="true"
												width="130">
											<template  slot-scope="scope">
												<div v-if="scope.row.prodid">
													{{scope.row.prodid}}
												</div>
												<div v-else>
													<el-button

															type="text"
															size="small"
															@click="zhuanhzhenshiwuliao(scope.row)"
															class="h-tableLink h-btn" >
														 虚拟物料<br>
														转换真实物料
													</el-button>
												</div>

											</template>
										</el-table-column>
										<el-table-column
												prop="prodname"
												label="产品型号"
												:show-overflow-tooltip="true"
												min-width="140">
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.prodname}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
												prop="proddes"
												label="产品描述"
												:show-overflow-tooltip="true"
												min-width="150">
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.proddes}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
												prop="prodnum"
												label="采购数量"
												:show-overflow-tooltip="true"
												width="100">
												<template slot-scope="scope">
													<div style="text-align: right;">
														{{scope.row.prodnum}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
												label="询价截止日期"
												min-width="170"
												:rules="[{ required: true, message: '请输入询价截止日期', trigger: 'blur'},]"
												prop="timeOut">
											<template scope="scope" v-if="xunjiaflag">
												<el-date-picker
														class="h-tableInput"
														v-model="scope.row.timeOut"
														type="date"
														style="width:100%;"
														value-format="yyyy-MM-dd"
														placeholder="--选择--"
														@change="submitTimeout($event,scope.row)"
														:picker-options="{
															disabledDate(time) {
																return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
															}
														}">
												</el-date-picker>

											</template>
										</el-table-column>
										<el-table-column
												prop="gyssl"
												label="询价供应商数量"
												:show-overflow-tooltip="true"
												width="150">
												<template slot-scope="scope">
													<div style="text-align: right;">
														{{scope.row.gyssl}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
												prop="gysybjsl"
												label="已报价供应商数量"
												:show-overflow-tooltip="true"
												width="170">
												<template slot-scope="scope">
													<div style="text-align: right;">
														{{scope.row.gysybjsl}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
												prop="supid"
												label="确认供应商编码"
												:show-overflow-tooltip="true"
												width="150">
										</el-table-column>
										<el-table-column
												prop="supname"
												label="确认供应商名称"
												:show-overflow-tooltip="true"
												width="150">
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.supname}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
												prop="unitprice"
												label="确认报价"
												:show-overflow-tooltip="true"
												width="100">
												<template slot-scope="scope">
													<div style="text-align: right;">
														{{scope.row.unitprice}}
													</div>
												</template>
										</el-table-column>
										<el-table-column
												prop="currency"
												min-width="100"
												:show-overflow-tooltip="true"
												label="币种">
											<template slot-scope="scope">
												{{scope.row.currency | dictname('YLCurrency')}}
											</template>
										</el-table-column>
										<el-table-column
												label="供应商报价单"
												width="180"
										>
											<template slot-scope="scope">
												<brupload
														:refid=scope.row.id
														reftype="询价报价单附件"
														:showtime="false"
												>
												</brupload>
											</template>
										</el-table-column>

										<el-table-column
												v-if="xunjiaflag"
												width="120"
												label="操作"
												fixed="right">
											<template slot-scope="scope">
												<el-button
														type="text"
														size="small"
														@click="zhidinggys(scope.row)"
														class="h-tableLink h-btn" >
													选择供应商
												</el-button>
												<!-- <div class="l-operationBox">
													<span class="l-operationlist br-operation-xzgys" title="选择供应商" @click="zhidinggys(scope.row)"></span>
												</div> -->
											</template>
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="h-txtCenter h-mrt60">
					<el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoback">返回</el-button>
					<el-button class="h-btn h-bBtn h-bgblueQ2" @click="shoudongjishu" v-if="this.formLabelAlign.xunjiaFlag ==0 && xunjiaflag">手动结束询价</el-button>
				</div>
			</div>
		</div>
		<el-dialog :close-on-click-modal="false" title="发起询价供应商列表" :visible.sync="dialogTableVisible" width="60%" >
			<div class="h-rowIn" >
				<div class="h-rowBox">
				<el-table
						max-height="450"
						:data="gysbaojialist"
						:border="true"
						style="width: 100%">
					<el-table-column
							prop="supid"
							label="供应商编码"
							:show-overflow-tooltip="true"
							min-width="90">
					</el-table-column>
					<el-table-column
							prop="supname"
							label="供应商名称"
							:show-overflow-tooltip="true"
							min-width="160">
					</el-table-column>
					<el-table-column
							prop="suptime"
							min-width="120"
							:show-overflow-tooltip="true"
							label="报价时间">
					</el-table-column>
					<el-table-column
							prop="unitprice"
							min-width="100"
							:show-overflow-tooltip="true"
							label="报价金额">
					</el-table-column>
					<el-table-column
							prop="currency"
							min-width="100"
							:show-overflow-tooltip="true"
							label="币种">
						<template slot-scope="scope">
							{{scope.row.currency | dictname('YLCurrency')}}
						</template>
					</el-table-column>
					<el-table-column
							label="报价单"
							width="160"
					>
						<template slot-scope="scope">
							<brupload
									:refid=scope.row.id
									reftype="询价报价单附件"
									:showtime="false"
							>
							</brupload>
						</template>
					</el-table-column>
					<el-table-column
							width="200"
							label="操作"
							fixed="right">
						<template slot-scope="scope">
							<div v-if="scope.row.unitprice">
								<el-button
										type="text"
										size="small"
										@click="gysbjhistory_click(scope.row)"
										class="h-tableLink h-btn" >
									历史报价
								</el-button>
							</div>
							<el-button
									type="text"
									size="small"
									@click="querengys(scope.row)"
									class="h-tableLink h-btn" >
								确认供应商
							</el-button>
						</template>
					</el-table-column>
				</el-table>
					<paginationminNosize :page="gysbaojiaform" @query="gysBaojiaPage" style="padding-top: 0.1rem"/>
				</div>
			</div>
		</el-dialog>
		<addxunjz :visible.sync="showaddxunjzflag" v-if="showaddxunjzflag"
				  @addoneXunjiazu="addoneXunjiazu"  :xmid="this.$route.query.id"/>

		<addwuliao :visible.sync="showaddwuliaoflag" @callback="successRefreshList"
				   v-if="showaddwuliaoflag" :chanpid="this.mdmchanpid" :xinghao="this.mdmxinghao"/>

		<gysbjhistory :visible.sync="gysbjhistory_showflag"
					  v-if="gysbjhistory_showflag"
					  :gyscode="this.nowgyscode"
					  :proinfoid="this.proinfoid" :xmcode="this.xmcode"/>
	</div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import addxunjz from '../../../components/project/addxunjz'
    import addwuliao from '../../../components/project/addwuliao'
    import gysbjhistory from '../../../components/project/gysbjhistory'

    export default {
        components:{
            addxunjz,
            addwuliao,
            gysbjhistory
		},
        data() {
            return {
				xunjiaflag:true,
                xmcode:null,
                showaddxunjzflag:false,
                showaddwuliaoflag:false,
                gysbjhistory_showflag:false,
                formLabelAlign: {},
                item:[],
                grouplist:[],
                dialogTableVisible:false,
                gysbaojialist:[],
                currentOpenRow:null,

                nowgyscode:null,
                proinfoid:null,

				//创建物料
				mdmchanpid:null,
				mdmxinghao:null,

				gysbaojiaform:{
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                	lastflag:0,
					xmcode:null,
                    proinfoid:null,
				},
            }
        },
        created() {
            this.xmcode = this.$route.query.id;
            this.query();
            // 初始化已经做好的组
            this.initData();
        },
        methods: {
            initData(){
                ss.ProService.grouplist({xmcode:this.xmcode}).then(rd => {
                    console.log("询价组信息：",rd)
					 this.grouplist=rd.obj;
					 this.grouplist.forEach((obj)=>{
						 if (obj.isCompliete == 1) {
							 // this.xunjiaflag = false;
						 }
					 })
                });
			},
            query() {
                ss.ProService.proDetail(this.xmcode).then(rd => {
                    console.log("项目：",rd)
                    this.formLabelAlign = rd;
                });
            },
            zhidinggys(r){
                this.currentOpenRow = r;
                this.gysbaojiaform.xmcode = this.xmcode;
                this.gysbaojiaform.proinfoid = r.proinfoid;
                this.gysBaojiaPage();
			},
			gysBaojiaPage(){
                ss.ProService.gysbjlistPage(this.gysbaojiaform).then(rd => {
                    console.log("供应商报价信息：",rd)
                    this.gysbaojiaform.total = rd.obj.total;
                    this.gysbaojialist = rd.obj.records;
                    this.dialogTableVisible=true;
                });
			},
            gysbjhistory_click(r){
				this.gysbjhistory_showflag=true;
				this.nowgyscode = r.supid
				this.proinfoid = r.proinfoid
			},
            querengys(r){
                if(_.trim(r.unitprice) == '') {
                    this.$msg.msge("该供应商未报价，无法选择");
                    return;
				}
                this.$msg.confirm("确认选择该供应商？",()=>{
                    this.currentOpenRow = null;
                    this.dialogTableVisible=false
                    ss.ProService.pointGys(r).then(rd => {
                        this.$msg.msgs("选定供应商成功！");
                        this.initData();
                    });
                })
			},
            submitTimeout(v,row){
                // console.log(v)
                // console.log(row)
				row.xmcode = this.xmcode;
                ss.ProService.submitTimeout(row).then(rd => {
                    this.$msg.msgs("维护报价截止日期成功！");
                    this.initData();
                });
			},
            showaddxunjzflagclick(){
                this.showaddxunjzflag=true;
			},
            addoneXunjiazu(wllist,gyslist){
				this.$msg.confirm("确认发起询价?", () => {
					this.showaddxunjzflag=false;
					this.addGroup(wllist,gyslist);
				});
			},
			addGroup(wllist,gyslist){
				var id = this.$util.getUuid();
				var form={
                    groupid:id,
                    xmcode:this.xmcode,
                    proinfoids:_.map(wllist,"id"),
                    gyscodes:_.map(gyslist,"usercode"),
				}
				ss.ProService.saveXunjiazu(form).then(rd=>{
                    // 初始化已经做好的组
                    this.initData();
				});
			},
            zhuanhzhenshiwuliao(r){
                this.mdmchanpid = r.proinfoid
				this.mdmxinghao = r.prodname
                this.showaddwuliaoflag=true;
			},
			successRefreshList(){
                this.initData();
                this.showaddwuliaoflag=false
			},
            quxiaoback(){
              this.$router.back();
			},
            shoudongjishu(){
                this.$msg.confirm("未到询价截止日期，是否确认手动结束询价？",()=>{
					var r = [];
					this.grouplist.forEach((obj)=>{
						r.push({
							"productId":obj.proinfoid,
							"supplierId":obj.supid,
							"inquiryId":obj.inquiryid
						})
					})
                    ss.ProService.commitInquiry(r).then(rd => {
                        this.$msg.msgs("询价已结束");
						this.xunjiaflag = false;
                    });
                })
			}
        }
    }

</script>
<style>
	.ljjxjbjzdgys .h-tableInput .el-input__inner {
	    padding: 0.05rem 0.1rem;
	}
	.ljjxjbjzdgys .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
